import { getUpdateAnsweredQuestionsStack } from '#app/features/form/wizard/utils/getUpdatedAnsweredQuestionsStack.ts'
import { type JSONState } from '#types/form/wizard.ts'
interface HandleJSONStateParams<T> {
	id: string
	type: JSONState<T>['type']
	answeredQuestionsStack: JSONState<T>['answeredQuestionsStack']
	currentQuestionId: JSONState<T>['currentQuestionId']
	currentQuestionTreeId: JSONState<T>['currentQuestionTreeId']
	typeOfQuestion: 'radio' | 'text' | 'number'
	formState: JSONState<T>['formState']
	oldFormState: JSONState<T>['oldFormState']
}

export function getUserHasUpdatedJSONForm<T>({
	id,
	type,
	answeredQuestionsStack,
	currentQuestionId,
	currentQuestionTreeId,
	typeOfQuestion,
	formState,
	oldFormState,
}: HandleJSONStateParams<T>) {
	const updatedAnsweredQuestionsStack = getUpdateAnsweredQuestionsStack({
		answeredQuestionsStack,
		currentQuestionId,
		id,
		type,
		currentQuestionTreeId,
	})

	const currentAnsweredQuestionsStack = updatedAnsweredQuestionsStack!.find(
		item => item.id === currentQuestionTreeId,
	)

	if (typeOfQuestion === 'text') {
		const newAnswers = currentAnsweredQuestionsStack?.answers

		const currentQuestionIds = newAnswers?.map(answer => ({
			id: `${id}-${answer}`,
		}))

		const grabValuesFromCurrentFormState = (
			currentQuestionIds: any,
			formState: any,
		) => {
			const values: any = {}

			currentQuestionIds.forEach((questionId: any) => {
				const value = formState[questionId.id]
				values[questionId.id] = value
			})

			return values
		}

		const oldValues = grabValuesFromCurrentFormState(
			currentQuestionIds,
			oldFormState as JSONState<typeof oldFormState>,
		)

		const newValues = grabValuesFromCurrentFormState(
			currentQuestionIds,
			formState as JSONState<typeof formState>,
		)

		const userHasNotUpdatedCurrentJSONTree = Object.keys(oldValues).every(
			key => oldValues[key] === newValues[key],
		)

		return {
			userHasNotUpdatedCurrentJSONTree,
		}
	}

	if (typeOfQuestion === 'radio') {
		const oldAnswers = currentAnsweredQuestionsStack?.previousAnswers
		const newAnswers = currentAnsweredQuestionsStack?.answers

		const userHasNotUpdatedCurrentJSONTree = (
			oldAnswers: any,
			newAnswers: any,
		) => {
			const oldAnswersArray = Object.entries(oldAnswers)
			const newAnswersArray = Object.entries(newAnswers)

			const oldAnswersArrayLength = oldAnswersArray.length
			const newAnswersArrayLength = newAnswersArray.length

			if (oldAnswersArrayLength !== newAnswersArrayLength) {
				return false
			}

			for (let i = 0; i < oldAnswersArrayLength; i++) {
				const oldAnswer = oldAnswersArray[i]
				const newAnswer = newAnswersArray[i]

				if (oldAnswer[0] !== newAnswer[0]) {
					return false
				}

				if (oldAnswer[1] !== newAnswer[1]) {
					return false
				}
			}

			return true
		}

		return {
			userHasNotUpdatedCurrentJSONTree: userHasNotUpdatedCurrentJSONTree(
				oldAnswers,
				newAnswers,
			),
		}
	}

	return { userHasNotUpdatedCurrentJSONTree: true }
}
